<template>
  <div class="blog-main-content">
    <BlogList class="right"/>
    <h1>Flayer Jungle / Flayer Dungeon (Terror Zone) Efficient Run Guide</h1>

    <h2>Route Planning</h2>
    <ol>
        <li><strong>Teleport to Flayer Jungle:</strong>
            <ul>
                <li>Flayer Jungle has a waypoint, so all players can teleport directly from town without extra travel time.</li>
            </ul>
        </li>
        <li><strong>Quickly Clear Flayer Dungeon (First Level Only):</strong>
            <ul>
                <li><span class="highlight">Only farm the first level!</span> The second and third levels are not recommended because they contain Dead Flayers, which explode on death, potentially killing players and causing experience loss.</li>
                <li>The entrance to Flayer Dungeon is random. Enter, clear elite packs, and exit quickly.</li>
            </ul>
        </li>
        <li><strong>Focus on Flayer Jungle:</strong>
            <ul>
                <li>This area has high monster density, making it ideal for efficient experience farming.</li>
                <li>Prioritize large groups of Flayers, as they have low health but appear in large numbers, providing excellent XP.</li>
                <li>Don’t waste time on scattered monsters—if enemies are too spread out, move quickly to find new targets.</li>
            </ul>
        </li>
        <li><strong>Restart the game</strong> after clearing the area and repeat the process for maximum efficiency.</li>
    </ol>
    <div>
      <img class="m-1 w-100" alt="Flayer Jungle run" src="@/assets/runs/flayer-jungle-run.png">
    </div>

    <h2>Farming Strategies</h2>
    <ul>
        <li><strong>AOE Damage for Fast Clearing:</strong> High-AOE builds like Wind Druid, Lightning Sorceress, and Trapsin are ideal for efficiently killing large groups of monsters.</li>
        <li><strong>Avoid Getting Swarmed:</strong> Flayers attack quickly, so use crowd control skills like Frost Nova, Hurricane, or Corpse Explosion to prevent being overwhelmed.</li>
        <li><strong>Skip the Second and Third Levels of Flayer Dungeon:</strong> Dead Flayers explode upon death, posing a serious risk of killing players and causing experience loss.</li>
        <li><strong>Be Aware of Lightning-Immune Monsters:</strong> Lightning Sorceresses should have Infinity to break immunities, or rely on teammates with different damage types.</li>
    </ul>

    <div id="slot-content_mpu" class="content-ad-mpu"/>

    <h2>Advantages of Flayer Jungle / Flayer Dungeon Farming</h2>
    <ul>
        <li><strong>High monster density</strong> in Flayer Jungle, making it a great place for XP farming.</li>
        <li><strong>Perfect for AOE builds</strong>, as large packs of monsters can be cleared quickly.</li>
        <li><strong>Flayer Jungle has a waypoint</strong>, allowing all players to instantly reach the farming area.</li>
    </ul>

  </div>
</template>

<script>
import BlogList from '../BlogList.vue'

export default {
  name: 'FlayerJungle',

  components: {
    BlogList,
  },
}
</script>